var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignsEmptyStateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.35098 24.7139C2.30386 22.7317 4.01224 21.1103 6.24485 20.3294L9.61918 19.1473L33.7446 1.28654C34.1882 0.783567 34.7145 0.416399 35.3257 0.202071C37.5158 -0.56408 40.088 0.889661 42.4841 3.86294C46.9684 9.43603 50.5254 19.5951 50.4999 26.7513C50.4829 30.5671 49.3772 33.3088 47.1891 34.077C46.5779 34.2914 45.937 34.3317 45.2792 34.215L17.1127 35.2825L19.948 43.3726C20.3491 44.5123 20.243 45.7113 19.7592 46.7258C19.2732 47.7296 18.3797 48.5912 17.2486 48.9753C14.9204 49.7648 12.4395 48.5466 11.6461 46.2737L8.4012 37.01C5.01833 36.7426 2.05989 34.3423 0.981999 31.2609C0.201017 29.0325 0.400514 26.6917 1.35339 24.7115L1.35098 24.7139ZM40.1285 5.75571C36.5313 1.28626 35.0542 2.58935 35.0372 7.54054C35.033 8.79054 35.1518 10.2018 35.4044 11.7235C36.8347 11.6534 38.2312 12.0121 39.4324 12.7061C44.0567 15.3758 44.3687 21.9208 40.0605 25.0257C40.816 26.3691 41.6013 27.5491 42.3887 28.5253C45.4935 32.3836 47.4587 32.4769 47.4799 26.7405C47.5054 20.278 44.182 10.7959 40.1264 5.75799L40.1285 5.75571Z",
    fill: "#A7AEB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignsEmptyStateIcon);
export default __webpack_public_path__ + "static/media/campaignsEmptyStateIcon.35277787db3568af402cb97607e05b6d.svg";
export { ForwardRef as ReactComponent };